import { environment } from 'src/environments/environment'
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'
import { Directive } from '@angular/core';
import { Injectable, } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { sweetalert } from "../services/sweetalert";
@Directive({
  selector: 'app-otpservice'
})
@Injectable()
export class otpservice {
  resendresponse: any;
  resendstatus: Subject<any>;
  resendmessage: any;
  constructor(private sweetalert: sweetalert, private httpClient: HttpClient) {

  }

  mobile: any;
  otp: any;
  found: boolean;
  seqno: any;
  message: Subject<any>;
  verificationresponse: any;
  verificationmessage: any;
  response: any;
  statuscode: Subject<any>;
  data: any;
  


  getotp(): Promise<any> {
    const headers = new HttpHeaders("Access-Control-Allow-Origin: *");
    var mobileNo = localStorage.getItem("mobilenum");
    var name = "getOtp";
    //return this.httpClient.get(environment.baseUrl+"/tvsm/getotpController/"+name+"/"+mobile,{ headers})
    return this.httpClient.post(environment.baseUrl + "/tvsm/getotp",
      {
        name,
        mobileNo,
        "method": "get",
      })
      .toPromise()
      .then(datavalue => {
        this.response = (datavalue);
        console.log("sms" + JSON.stringify(this.response))
        this.seqno = this.response.data.seqno;
        this.message = this.response.data.message;
        let otpModel = document.getElementById("otpModel") as HTMLDivElement;
           otpModel.style.display = 'block';
          console.log("otpmodel"+JSON.stringify(otpModel))
      })
      .catch((err: HttpErrorResponse) => {
        this.sweetalert.UTP_sweertalert();
        //throw new console.log("Unable to process")

      });
  }




  resendotp() {
    var mobileNo = localStorage.getItem("mobilenum");;
    var name = "resendOTP";
    var seqno = this.seqno;
    return this.httpClient.post(environment.baseUrl + "/tvsm/getotp", {
      mobileNo,
      name,
      "method": "get",
      seqno
    })
      .toPromise()
      .then(
        data => {
          this.resendresponse = data;
          this.resendstatus = this.resendresponse.statusCode;
          this.resendmessage = this.resendresponse.data.message;
        })
      .catch((err: HttpErrorResponse) => {
        this.sweetalert.UTP_sweertalert();
        //throw new console.log("Unable to process")
      });


  }



  verifyotp() {
    var mobileNo = localStorage.getItem("mobilenum");
    var name = "getOtpVerify";
    var otpnumber = this.otp;
    var seqno = this.seqno;
    sessionStorage.setItem("seqno", seqno);
    return this.httpClient.post(environment.baseUrl + "/tvsm/getotp",
      {
        mobileNo,
        name,
        otpnumber,
        seqno,
        "method": "get",
      })
      .toPromise()
      .then(
        datavalue => {
          this.verificationresponse = datavalue;
          console.log("sms" + JSON.stringify(this.verificationresponse))
          this.verificationmessage = this.verificationresponse.data.message;
          sessionStorage.setItem("verificationmessage", this.verificationmessage);
          this.statuscode = this.verificationresponse.statusCode;
        })
      .catch((err: HttpErrorResponse) => {
        this.sweetalert.UTP_sweertalert();
        //throw new console.log("Unable to process")

      });


  }
}